import { NAV_ACTIVATE, NAV_ENABLE, NAV_RESPONSIVE, NAV_CONTROLFLOAT } from './actionDefinitions';

export function navActivate(active) {
    return { type: NAV_ACTIVATE, active };
}

export function navEnable(enabled) {
    return { type: NAV_ENABLE, enabled };
}

export function navResponsive(responsive) {
    return { type: NAV_RESPONSIVE, responsive };
}

export function setNavToggleFloat(floatNavToggle) {
    return { type: NAV_CONTROLFLOAT, floatNavToggle };
}
